<template>
  <v-container fluid>
    <v-snackbar v-model="showSnackbar" :color="snackbar.color" transition="slide-y-reverse-transition">
      {{ snackbar.message }}
      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="showSnackbar = false"
        >
          {{getTranslated('_close')}}
        </v-btn>
      </template>
    </v-snackbar>

    <ConfirmationDialog
      :showDialog="showConfirmationDialog"
      :text="getTranslated('_usrUserAccessPermitWillDeleted')"
      @accept="deleteUsr_UserAccessPermit"
      @cancel="cancelDeleteDialog"
    ></ConfirmationDialog>

    <UsrUserAccessPermitEditionDialog
      :openDialog="showEditionDialog"
      @input="showEditionDialog = false"
      @saved="notify"
      :translations="translations"
    ></UsrUserAccessPermitEditionDialog>

    <v-skeleton-loader
      :loading="tableLoading"
      type="table"
      class="elevation-1 my-12"
      transition="fade-transition"
    >
      <v-data-table
        must-sort
        :headers="headers"
        :items="usr_useraccesspermitList"
        width="100%"
        :hide-default-footer="usr_useraccesspermitList.length <= 10"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>{{getTranslated('_usrUserAccessPermits')}}</v-toolbar-title>
            <v-divider
              class="mx-4"
              inset
              vertical
            ></v-divider>
            <div class="flex-grow-1"></div>
            <v-btn color="primary" dark class="mb-2" icon x-large @click.stop="showEditionDialog=true" v-if="permits.writePermit" disabled>
              <v-icon>
                add_circle
              </v-icon>
            </v-btn>
          </v-toolbar>
        </template>

        <template #item.action="{ item }">
          <v-icon
            small
            class="mr-1"
            @click="editUsr_UserAccessPermit(item)"
          >
            edit
          </v-icon>
          <span class="text-overline" style="cursor: pointer" @click="editUsr_UserAccessPermit(item)">{{getTranslated('_edit')}}</span>
          <v-icon
            small
            class="mr-1 ml-4"
            @click="openDeleteDialog(item)"
          >
            delete
          </v-icon>
          <span class="text-overline" style="cursor: pointer" @click="openDeleteDialog(item)">{{getTranslated('_delete')}}</span>
        </template>

        <template #no-data>
          <label>{{getTranslated('_usrUserAccessPermitNoData')}}</label>
        </template>
      </v-data-table>
    </v-skeleton-loader>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { actions } from '../store/types/usr_useraccesspermitTypes.js'
import usrUseraccesspermitsService from '../services/Usr_UserAccessPermitsService.js'
import translationsService from '../services/TranslationsService'
import screenService from '../services/ScreenService.js'
const UsrUserAccessPermitEditionDialog = () =>
  import('../components/UsrUserAccessPermitEditionDialog.vue')
const ConfirmationDialog = () =>
  import('../components/ConfirmationDialog.vue')

export default {
  components: {
    UsrUserAccessPermitEditionDialog,
    ConfirmationDialog
  },
  data () {
    return {
      tableLoading: true,
      showSnackbar: false,
      snackbar: {
        color: '',
        message: ''
      },
      showConfirmationDialog: false,
      showEditionDialog: false,
      usr_useraccesspermitToDelete: '',
      translations: [
        { key: '_required', translation: 'Required' },
        { key: '_usrUserAccessPermitWillDeleted', translation: 'Usr User Access will be deleted' },
        { key: '_close', translation: 'Close' }
      ],
      permits: ''
    }
  },
  computed: mapState({
    headers: state => state.usruseraccesspermits.headers,
    usr_useraccesspermitList: state => state.usruseraccesspermits.usruseraccesspermitList
  }),
  methods: {
    ...mapActions({
      saveCurrentUsr_UserAccessPermit: actions.SAVE_CURRENT_USR_USERACCESSPERMIT,
      getUsr_UserAccessPermits: actions.GET_USR_USERACCESSPERMITS,
      savePagination: actions.SAVE_PAGINATION,
      getHeaders: actions.GET_HEADERS
    }),
    editUsr_UserAccessPermit (item) {
      this.saveCurrentUsr_UserAccessPermit(item)
      this.showEditionDialog = true
    },
    openDeleteDialog (item) {
      this.showConfirmationDialog = true
      this.usr_useraccesspermitToDelete = item.id
    },
    async deleteUsr_UserAccessPermit (item) {
      await usrUseraccesspermitsService.deleteUsr_UserAccessPermit(this.usr_useraccesspermitToDelete).then(res => {
        this.cancelDeleteDialog()
        this.getUsr_UserAccessPermits()
        this.snackbar.color = res.request.status === 200 ? 'green' : 'red'
        this.snackbar.message = res.request.status === 200 ? this.getTranslated('_UsrAccessPermitDeleted') : this.getTranslated('_UsrAccessPermitDeletedError')
        this.showSnackbar = true
      }).catch((e) => this.errorManagement(e))
    },
    cancelDeleteDialog () {
      this.showConfirmationDialog = false
      this.usr_useraccesspermitToDelete = ''
    },
    notify (notification) {
      this.snackbar.color = notification.color
      this.snackbar.message = notification.message
      this.showSnackbar = true
    },
    async loadUsr_UserAccessPermits () {
      await this.getUsr_UserAccessPermits().catch((e) => this.errorManagement(e))
      this.tableLoading = false
    },
    async initialize () {
      if (this.$root.$data.user.profile !== undefined) {
        this.permits = await screenService.getScreenPermits('Usr_UserAccessPermits', this.$root.$data.user.profile['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier']).catch((e) => this.errorManagement(e))
        this.permits = this.permits.data
        await this.getTranslations().catch((e) => this.errorManagement(e))
        await this.getHeaders('Usr_UserAccessPermits').catch((e) => this.errorManagement(e))
        this.headers.forEach(element => {
          // Especificamos el tamaño del campo action
          if (element.value === 'action') {
            element.width = '320px'
          }
        })
      }
    },
    async getTranslations () {
      if (this.$root.$data.user.profile !== undefined) {
        await translationsService.get('Usr_UserAccessPermits', this.$root.$data.user.profile['customclaim-language']).then(res => {
          this.translations = res.data
        })
      }
    },
    getTranslated (key) {
      var translation = this.translations.filter(element => element.key === key)
      if (translation.length > 0) {
        return translation[0].translation
      } else {
        return 'Translation Error: ' + key
      }
    },
    errorManagement (e) {
      if (e.response !== undefined) {
        switch (e.response.status) {
          case 401:
            this.notify({ color: 'warning', message: 'Unauthorized error' })
            break
          case 422:
            this.notify({ color: 'warning', message: 'Unprocessable Entity error' })
            break
          case 500:
            this.notify({ color: 'warning', message: 'Internal server error' })
            break
          default:
            this.notify({ color: 'warning', message: 'Unexpected error' })
            break
        }
      } else {
        this.notify({ color: 'warning', message: 'Unexpected error' })
      }
    }
  },
  async created () {
    await this.initialize()
    this.loadUsr_UserAccessPermits()
  }
}
</script>
